import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=f351190c&scoped=true"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=f351190c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f351190c",
  null
  
)

export default component.exports